'use es6';

import { Record } from 'immutable';
export default Record({
  type: 'info',
  content: ''
}, 'UserMessage');